import React, {useEffect, useState} from 'react'
import {IconTypeEnum} from '../theme/icons'
import {StyledAddIcon, StyledArrowDownIcon, StyledLessIcon,} from '../components/Collapse/Collapse.styled'
import pxToRem from '../utils/pxToRem'
import {CollapseEnumType} from '../components/Collapse/Collapse'
import theme from '../theme/theme-style'

const useCollapseConfig = (
    hasSelectedChild,
    collapseType,
    iconType,
    isOpen,
    isChild,
    level,
    currentPage
) => {


    const [iconConfig, setIconConfig] = useState({
        icon: null,
        height: null,
        width: null,
        color: null,
    })
    const [colorConfig, setColorConfig] = useState(null)
    const [bgConfig, setBgConfig] = useState(null)
    const [collapseConfig, setCollapseConfig] = useState({
        iconConfig,
        color: null,
        background: null,
    })

    const getIconConfig = (iconType, isOpen, currentPage, hasSelectedChild) => {
        const config = {icon: null, height: null, width: null, color: null}
        switch (iconType) {
            case IconTypeEnum.arrowDown:
                config.icon = <StyledArrowDownIcon $isOpen={isOpen || currentPage}/>
                config.height = pxToRem(6)
                config.width = pxToRem(10.5)
                config.color =
                    level === 0
                        ? isOpen
                            ? theme.colors.unique.black
                            : theme.colors.unique.white
                        : level === 2
                            ? theme.colors.unique.white
                            : theme.colors.unique.black
                break
            case IconTypeEnum.add:
                config.height = pxToRem(18)
                config.width = pxToRem(18)
                config.color = hasSelectedChild
                    ? theme.colors.unique.white
                    : theme.colors.unique.black
                if (!isOpen && !currentPage) {
                    config.icon = <StyledAddIcon $isOpen={isOpen || currentPage}/>
                } else {
                    config.icon = <StyledLessIcon $isOpen={isOpen || currentPage}/>
                }
                break
            default:
                break
        }
        return config
    }

    const getColorConfig = (collapseType, isOpen, currentPage, hasSelectedChild) => {
        switch (collapseType) {
            case CollapseEnumType.Navbar:
                return level === 0
                    ? isOpen
                        ? theme.colors.unique.black
                        : theme.colors.unique.white
                    : level === 2
                        ? theme.colors.unique.white
                        : theme.colors.unique.black
            case CollapseEnumType.SideNav:
                return hasSelectedChild || (currentPage && !isChild) || (isOpen && hasSelectedChild)
                    ? theme.colors.unique.white
                    : theme.colors.unique.black
        }
    }

    const getBgConfig = (collapseType, isOpen, currentPage, hasSelectedChild) => {
        switch (collapseType) {
            case CollapseEnumType.Navbar:
                return level === 0
                    ? isOpen
                        ? theme.colors.unique.white
                        : theme.colors.unique.black
                    : level === 1
                        ? 'inherit'
                        : level === 2
                            ? theme.colors.unique.black
                            : theme.colors.unique.white
            case CollapseEnumType.SideNav:
                return hasSelectedChild || (currentPage && !isChild) || (isOpen && hasSelectedChild)
                    ? theme.colors.unique.black
                    : isChild ? theme.colors.secondary.grey90 : theme.colors.unique.white
        }
    }

    useEffect(() => {
        const config = getIconConfig(iconType, isOpen, currentPage, hasSelectedChild)
        setIconConfig(config)
        const color = getColorConfig(collapseType, isOpen, currentPage, hasSelectedChild)
        setColorConfig(color)
        const bgConfig = getBgConfig(collapseType, isOpen, currentPage, hasSelectedChild)
        setBgConfig(bgConfig)
    }, [collapseType, iconType, isOpen, currentPage, hasSelectedChild])

    useEffect(() => {
        setCollapseConfig({iconConfig, color: colorConfig, background: bgConfig})
    }, [iconConfig, colorConfig, bgConfig])

    return collapseConfig
}

export default useCollapseConfig
